// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 2.5C7.77831 2.5 9.43758 2.85851 10.6895 3.48438C11.1588 3.71903 11.6153 4.01898 11.998 4.38086C12.1252 4.25976 12.2601 4.14673 12.3994 4.04199L13.1982 3.44043L14.4004 5.03906L13.6006 5.63965C13.1071 6.01077 13.0001 6.31965 13 6.5V19.1504C13.1024 19.092 13.2063 19.0365 13.3105 18.9844C14.5624 18.3585 16.2217 18 18 18C19.0648 18 20.0848 18.1298 21 18.3662V9H23V21.3066L21.5918 20.6768C20.6801 20.2688 19.4213 20 18 20C16.4648 20 15.1238 20.3136 14.2041 20.7734C13.2254 21.2629 13.0001 21.7544 13 22H11C10.9999 21.7544 10.7747 21.263 9.7959 20.7734C8.87623 20.3136 7.53527 20 6 20C4.57862 20 3.31986 20.2688 2.4082 20.6768L1 21.3076V3.76953C1.22819 3.5947 1.33718 3.50597 1.44141 3.43359C1.50286 3.39092 1.60384 3.32787 1.74902 3.25391C1.9433 3.15497 2.21681 3.03768 2.58301 2.92578C3.3155 2.70198 4.4154 2.5 6 2.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.5322 3.4668L23.5693 4.75L20.5322 6.03223L19.25 9.06934L17.9668 6.03223L14.9307 4.75L17.9668 3.4668L19.25 0.430664L20.5322 3.4668Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-book-open-filled')
export default class AiBookOpenFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-book-open-filled',
    }
  }
}
